<section class="header boxs">
  <div class="head boxs">
    <div class="logo">
      <!-- <a [routerLink]="['/']"> -->
      <a (click)="goToLandingPage()">
        <img class="img-header" src="https://cdn-dev.obsidiam.com/img/logos/obsidiam_logo_full_white.png" srcset="https://cdn-dev.obsidiam.com/img/logos/obsidiam_logo_full_white@2x.png 3x,
                 https://cdn-dev.obsidiam.com/img/logos/obsidiam_logo_full_white@2x.png 3x" alt="Obsidiam">
      </a>
    </div>

    <div class="navi">
      <ul>
        <button class="hamburger hamburger--squeeze" [ngClass]="menuActive?'is-active':''" #humberg id="navbar-button"
          (click)="menuEvent(humberg)" type="button" aria-label="Menu" aria-controls="navigation">
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>
        <li class="side_li" *ngIf="url=='subscribe' || url=='forgot-password'"><a
            [routerLink]="['/login']">{{'login.login'|translate}}</a></li>
        <li class="side_li" *ngIf="url=='login'"><a [routerLink]="['/subscribe']">{{'signUp.signUp'|translate}}</a></li>
        <li>
          <div class="dropdown">
            <a class="nav-links dropdown-toggle" style="color: #fff; font-family: RalewayRegular,serif"
              href="javascript:;" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false">
              <img height="15px" style="margin: -3px 10px 0 0;"
                [src]="imgUrl + 'img/flags/obsidiam_' + currentLang.toString().toLowerCase() + '_flag.svg'">
            </a>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item language-options" *ngFor="let lang of languages;"
                (click)="changeLanguageLocal(lang.lang)" href="javascript:;">
                <img height="15px" style="margin: 5px 10px 0 0;"
                  [src]="imgUrl +'img/flags/obsidiam_' + lang.lang.toString().toLowerCase() + '_flag.svg'">
                {{lang.text}}
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>

</section>